import { BrowserRouter } from "react-router-dom";
import React, { useState, useRef } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.min.css";
import SideBar from "./SideBar/SideBar";
import Header from "./Header";
import Toaster from "./utility/ui/notifications/Toaster";
import "react-toastify/dist/ReactToastify.css";
import "./utility/ui/notifications/toast.css";
import { useSessionTimeout } from '../hooks/useSessionTimeout';
import { ICONS } from "./utility/common/constants/icons";


const Home = (props) => {
  useSessionTimeout();
  const mobileOpen = window.matchMedia("(max-width: 600px)").matches;
  const [isOpen, setIsOpen] = useState(false);
  const childRef = useRef();

  function openmenu() {
    childRef.current.mobiletoggle();
    setIsOpen(!isOpen);
  }

  function closemenu() {
    setIsOpen(false);
  }

  const getHamburgerDisplay = () => {
    if (!mobileOpen) return "none";
    return isOpen ? "none" : "block";
  };

  return (
    <BrowserRouter >
      <div className="Main">
        <div className="main">
          <SideBar ref={childRef} closemenu={closemenu} />
        </div>
        <div className="head" style={{ display: !isOpen ? "inline-block" : "none" }}>
          <div className="mobilelogo">
            <div className="hamburger" style={{
              display: getHamburgerDisplay(),
            }}
            >
              <img src={ICONS.Hamburger} onClick={openmenu} />
            </div>
            <div className="logo">
            </div>
          </div>
          <Header />
        </div>
        <div
          className="blurrOverlay"
          style={{ display: isOpen ? "block" : "none" }}
          onClick={openmenu}
        ></div>
        <Toaster />
      </div>
    </BrowserRouter>
  );
};

export default Home;